import axios from "../../axios";

const header = (token) => {
  return {
    headers: {
      Authorization: "Bearer " + token
    }
  }
}

export default {
  async getMetrics(token, params = {}) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/nps-feature/metrics';
    try {
      return await axios.get('', {
        params,
        ...header(token)
      });
    } catch (Exception) {
      throw Exception;
    }
  },
  async getPaginated(token, params = {}) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/nps-feature/paginated';
    try {
      return await axios.get('', {
        params,
        ...header(token)
      });
    } catch (Exception) {
      throw Exception;
    }
  }
}